"use client"

import { useEffect, useRef, useState } from "react"

export function useInView<T extends HTMLElement>(options?: IntersectionObserverInit) {
  const ref = useRef<T | null>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    if (!ref.current) return
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true)
    }, options)
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [options])

  return { ref, inView }
}
